const steps = [
  {
    number: '01',
    title: 'Alanınızı Videoya Çekin',
    desc: 'Temizlenecek alanın genel durumunu gösterecek kısa bir video hazırlayın.',
    icon: 'ri-video-chat-line',
  },
  {
    number: '02',
    title: "WhatsApp'tan Gönderin",
    desc: 'Videonuzu VİAYPİİ ekibine doğrudan iletin.',
    icon: 'ri-send-plane-line',
  },
  {
    number: '03',
    title: 'Teklifinizi Alın',
    desc: 'Alan ve yapılacak işler değerlendirilsin, ihtiyacınıza uygun çalışma planı ve teklif oluşturulsun.',
    icon: 'ri-file-list-3-line',
  },
];

const whatsappUrl = 'https://wa.me/905077089198?text=Merhaba%2C%20V%C4%B0AYP%C4%B0%C4%B0%20Temizlik%20i%C3%A7in%20teklif%20almak%20istiyorum.%20Temizlenecek%20alan%C4%B1n%20videosunu%20g%C3%B6ndermek%20istiyorum.';

export default function HowItWorks() {
  return (
    <section id="nasil-calisiyoruz" className="bg-warm-cream py-16 md:py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold text-navy mb-4">
            TEKLİF ALMAK ÇOK KOLAY
          </h2>
          <p className="text-navy/60 text-base md:text-lg max-w-xl mx-auto">
            Üç basit adımda size özel temizlik teklifinizi alın.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 md:gap-10 mb-12 md:mb-16">
          {steps.map((step, index) => (
            <div key={step.number} className="relative text-center">
              <div className="w-16 h-16 md:w-20 md:h-20 mx-auto mb-5 bg-navy rounded-full flex items-center justify-center text-gold">
                <i className={`${step.icon} text-2xl md:text-3xl`}></i>
              </div>
              <span className="inline-block text-gold font-display font-bold text-sm md:text-base mb-2">
                Adım {step.number}
              </span>
              <h3 className="font-display text-xl md:text-2xl font-bold text-navy mb-3">
                {step.title}
              </h3>
              <p className="text-navy/60 text-sm md:text-base leading-relaxed">
                {step.desc}
              </p>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-[calc(100%-20px)] w-[calc(100%-40px)] h-px bg-gold/30"></div>
              )}
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-8 py-4 bg-navy hover:bg-navy-light text-white font-bold text-base md:text-lg rounded-md transition-colors"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            VİDEOMU GÖNDERİP TEKLİF ALMAK İSTİYORUM
          </a>
        </div>
      </div>
    </section>
  );
}